import { apiClient } from './api'

export interface LabelPair {
  singular: string
  plural: string
}

export type LabelKey =
  | 'organization'
  | 'portfolio'
  | 'program'
  | 'project'
  | 'task'
  | 'milestone'
  | 'department'
  | 'team'
  | 'member'

export interface LabelsResponse {
  industry: string | null
  labels: Record<LabelKey, LabelPair>
}

export interface IndustryPreset {
  key: string
  name: string
  description: string
}

export type StatusEntityType = 'project' | 'task' | 'milestone' | 'portfolio' | 'program'

export interface StatusLabel {
  label: string
  color: string
}

export interface StatusLabelsResponse {
  industry: string | null
  entity_type: StatusEntityType | null
  statuses: Partial<Record<StatusEntityType, Record<string, StatusLabel>>>
}

export const labelsService = {
  getIndustries: () =>
    apiClient.get<IndustryPreset[]>('/api/v1/organizations/industries').then(r => r.data),

  getLabels: (orgId: number) =>
    apiClient.get<LabelsResponse>(`/api/v1/organizations/${orgId}/labels`).then(r => r.data),

  applyIndustry: (orgId: number, industry: string, resetOverrides = true) =>
    apiClient
      .post<LabelsResponse>(`/api/v1/organizations/${orgId}/apply-industry`, {
        industry,
        reset_overrides: resetOverrides,
      })
      .then(r => r.data),

  updateLabels: (orgId: number, labels: Partial<Record<LabelKey, LabelPair>>) =>
    apiClient
      .put<LabelsResponse>(`/api/v1/organizations/${orgId}/labels`, { labels })
      .then(r => r.data),

  getStatusLabels: (orgId: number, entityType?: StatusEntityType) =>
    apiClient
      .get<StatusLabelsResponse>(`/api/v1/organizations/${orgId}/status-labels`, {
        params: entityType ? { entity_type: entityType } : {},
      })
      .then(r => r.data),

  updateStatusLabels: (
    orgId: number,
    overrides: Partial<Record<StatusEntityType, Record<string, StatusLabel>>>,
  ) =>
    apiClient
      .put<StatusLabelsResponse>(`/api/v1/organizations/${orgId}/status-labels`, { overrides })
      .then(r => r.data),
}
